<script setup lang="ts">

import { useIsHostedInBrowser } from "@modules/Jupiter"
import type { IMarketplaceViewModel } from '@app/MyMarketplace/Types/IMarketplaceViewModel';
import { MarketplaceFilterType } from "@domain/Marketplace";
import FilterOption from "./FilterOption.vue";

import "./FilterMenu.scss";

const model = defineModel<IMarketplaceViewModel>( { required: true })
const isHostedInBrowser = useIsHostedInBrowser();

</script>

<template>

<div class="fixed bottom-0 left-0 w-full h-[100%] flex flex-col justify-end
            z-50 pointer-events-none 3xl:left-auto 3xl:max-w-xl 3xl:m-auto
            bg-gradient-to-b from-transparent via-10% via-black/50 to-black/50
            translate-y-12 opacity-0 transition-[transform,opacity] duration-300"
         :class="{
            '!opacity-100 !translate-y-0 pointer-events-auto': model.isFilterOpen
         }"
         @click="() => model.isFilterOpen = false">

        <div class="rounded-t-xl p-4 3xl:p-6
                    bg-gradient-to-b from-gray-850 to-gray-900"
             :class="{
                 '!pb-24': isHostedInBrowser 
              }">
        
            <div class="flex items-center justify-center pb-2">
                <div class="absolute rounded-full h-1 w-10 bg-white/10"/>
            </div>

            <div class="flex justify-center pt-2 pb-4 text-base tracking-wider">
                Choose what offers you want to see
            </div>

            <div class="tracking-wider text-base 3xl:text-lg">

                <div class="flex flex-col gap-2 3xl:gap-4">
                    <FilterOption title="In App and In Store Offers"
                                  icon="cashback"
                                  scale="scale-[80%]"
                                  :is-enabled="model.filterType == MarketplaceFilterType.All"
                                  @click.stop="model.setFilterType( MarketplaceFilterType.All )">
                        Show all the In App offers and the In Store offers         
                    </FilterOption>

                    <FilterOption title="In App Offers"
                                  icon="in-app"
                                  :is-enabled="model.filterType == MarketplaceFilterType.InApp"
                                  @click.stop="model.setFilterType( MarketplaceFilterType.InApp )">
                         Rewards are earned when you buy through the App.  
                         Follow the <strong>Open</strong> link on the offer to make your purchase on the  
                         merchants website
                    </FilterOption>

                    <FilterOption title="In Store Offers"
                                  icon="in-store"
                                  :is-enabled="model.filterType == MarketplaceFilterType.InStore"
                                  @click.stop="model.setFilterType( MarketplaceFilterType.InStore )">
                         Rewards are earned when you make a purchase in store.  
                         Just make sure you use the card that you linked to the app
                    </FilterOption>

                </div>

                <div class="flex items-center justify-center py-4 ">
                    <div class="absolute rounded-full h-1 w-10 bg-white/10"/>
                </div>

                <div>
                    <FilterOption title="Only Card Linked Offers"
                                  icon="credit-card"
                                  :is-enabled="model.cardLinkedOnlyEnabled"
                                  @click.stop="model.cardLinkedOnlyEnabled = !model.cardLinkedOnlyEnabled">
                        Only show offers where I get rewarded automatically when I use my linked card.
                        In store offers are always card linked
                    </FilterOption>
                </div>
                    
            </div>
        
        </div>

    </div>

</template>